import React, { useEffect, useState } from "react";

import morning1 from "../../assets/img/morning1.png";
import morning2 from "../../assets/img/morning2.png";
import afternoon1 from "../../assets/img/afternoon1.png";
import afternoon2 from "../../assets/img/afternoon2.png";
import sunset1 from "../../assets/img/sunset1.png";
import sunset2 from "../../assets/img/sunset2.png";
import night1 from "../../assets/img/night1.png";
import night2 from "../../assets/img/night2.png";
import cloudy1 from "../../assets/img/cloudy1.png";
import cloudy2 from "../../assets/img/cloudy2.png";
import rain1 from "../../assets/img/rain1.png";
import rain2 from "../../assets/img/rain2.png";
import thunderstorm1 from "../../assets/img/thunderstorm1.png";
import thunderstorm2 from "../../assets/img/thunderstorm2.png";

// TIME-BASED BACKGROUND IMAGE MAPPING
const timeBackgrounds = {
  morning: [morning1, morning2, cloudy1, cloudy2, rain1, rain2],
  afternoon: [afternoon1, afternoon2, cloudy1, cloudy2, rain1, rain2],
  evening: [
    sunset1,
    sunset2,
    cloudy1,
    cloudy2,
    rain1,
    rain2,
    thunderstorm1,
    thunderstorm2,
  ],
  night: [night1, night2, thunderstorm1, thunderstorm2],
};

function getTimeOfDay() {
  const hour = new Date().getHours();
  if (hour >= 5 && hour < 12) return "morning";
  if (hour >= 12 && hour < 17) return "afternoon";
  if (hour >= 17 && hour < 20) return "evening";
  return "night";
}

function getRandomImage(images) {
  return images[Math.floor(Math.random() * images.length)];
}

function Header({ onScrollDown }) {
  const [bgImage, setBgImage] = useState(null);
  const [showScrollMsg, setShowScrollMsg] = useState(true);
  const [showSelah, setShowSelah] = useState(true);

  useEffect(() => {
    const timeOfDay = getTimeOfDay();
    const images = timeBackgrounds[timeOfDay];
    setBgImage(getRandomImage(images));
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollMsg(window.scrollY <= 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSelah(false);
    }, 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <header className="relative h-screen overflow-hidden">
      {/* Background Image */}
      <div
        className={`absolute inset-0 bg-cover bg-center bg-no-repeat z-0 transition-opacity duration-1000 ${
          bgImage ? "opacity-100" : "opacity-0"
        }`}
        style={{ backgroundImage: bgImage ? `url(${bgImage})` : "none" }}
        role="img"
        aria-label="Imagen de fondo decorativa"
      />

      {/* Main Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-white">
        {showSelah && (
          <span
            className="font-bembo text-8xl font-bold fade-grow-disappear"
            aria-label="Texto destacado: Selah"
          >
            Selah
          </span>
        )}
      </div>

      {/* Scroll Down Indicator */}
      <button
        type="button"
        onClick={onScrollDown}
        className={`absolute bottom-6 left-1/2 transform -translate-x-1/2 z-20 text-center text-gray-300 transition-opacity duration-500 cursor-pointer ${
          showScrollMsg ? "opacity-100" : "opacity-0"
        }`}
        aria-label="Presiona para desplazarte hacia abajo"
      >
        <div className="text-sm font-bembo mb-1">Presiona para ir abajo</div>
        <div className="animate-bounce">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5 mx-auto"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1}
            role="presentation"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </div>
      </button>
    </header>
  );
}

export default Header;
